module.exports = __webpack_public_path__ + "img/cnc-03-residences.5ff5d54e.svg";